import React from 'react';
import { defaultTemplate } from 'core/hoc';

const ButtonAndLink = ({ label, btnClass, url, onClick, disabled }) => {
	return (
		<a href={url} target="_blank">
			<button className={btnClass} type="button" onClick={onClick} disabled={disabled}>
				{label}
			</button>
		</a>
	);
};

export default defaultTemplate(ButtonAndLink);



// WEBPACK FOOTER //
// ./src/common/utils/ButtonAndLink.jsx